import { render, staticRenderFns } from "./downloadInvoice.vue?vue&type=template&id=6287547b&scoped=true&"
import script from "./downloadInvoice.vue?vue&type=script&lang=js&"
export * from "./downloadInvoice.vue?vue&type=script&lang=js&"
import style0 from "./downloadInvoice.vue?vue&type=style&index=0&id=6287547b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287547b",
  null
  
)

export default component.exports